<template>
  <ranking-page
    endpoint="/spontan/ranking/total/points/year"
    heading-danish="Rangliste - Point i år"
    heading-english="Ranking - Points current year"
  />
</template>

<script>
import RankingPage from "./RankingPage.vue";

export default {
  components: { RankingPage },
};
</script>
